module.exports = __webpack_public_path__ + "img/es.42c0e6e1.svg";